var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndicapeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78039 2.84711C5.47643 2.78024 6.0172 2.15622 6.0172 1.42635C6.0172 0.640748 5.40146 0 4.64653 0C3.89159 0 3.27588 0.640748 3.27588 1.42635C3.27588 1.66592 3.34011 1.91107 3.4472 2.11722L3.93559 9.26856L8.96558 9.26998L11.0287 14.3002L13.7374 13.1948L13.3179 12.1555L11.802 12.7249L9.80586 7.92923L5.12906 7.96193L5.06485 7.05627L8.45048 7.05768V5.71765L4.9357 5.71622L4.78039 2.84711Z",
    fill: "#003E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83924 13.1031C8.99028 14.8495 7.21337 16 5.318 16C2.53417 16 0.263672 13.6373 0.263672 10.7404C0.263672 8.70639 1.44829 6.81623 3.21597 5.97834L3.33036 7.53176C2.28483 8.21735 1.64031 9.45438 1.64031 10.751C1.64031 12.8525 3.28739 14.5665 5.30684 14.5665C7.15441 14.5665 8.72988 13.091 8.94472 11.1982L9.83924 13.1031Z",
    fill: "#003E9C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndicapeIcon);
export default __webpack_public_path__ + "static/media/endicapeIcon.ceedb133fd5cce412aa46862a625d5e4.svg";
export { ForwardRef as ReactComponent };